module.exports = __webpack_public_path__ + "assets/images/activity-card-plus-icon.8f39a82b4410cbbd58d660694ef5b4b2.svg";